import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { devAPI } from '@/lib/api';

const COLOR: Record<string, string> = { healthy: 'bg-green-500', warning: 'bg-yellow-500', down: 'bg-red-500' };

export default function StatusPage() {
  const { data: health } = useQuery({ queryKey: ['health'], queryFn: () => devAPI.getHealth(), refetchInterval: 30000 });
  return (
    <div className="p-6 max-w-2xl">
      <h1 className="text-2xl font-bold text-gray-900 mb-1">System Status</h1>
      <p className="text-gray-600 mb-6">Live platform health.</p>
      {!health && <p className="text-gray-500">Checking…</p>}
      {health && (
        <div className="bg-white border border-gray-200 rounded-lg p-5">
          <div className="flex items-center mb-4">
            <div className={`w-3 h-3 rounded-full mr-2 ${COLOR[health.status] || 'bg-gray-400'}`} />
            <span className="font-medium capitalize">{health.status === 'healthy' ? 'All systems operational' : health.status}</span>
          </div>
          <div className="divide-y divide-gray-100">
            {(health.components || []).map((c: any) => (
              <div key={c.name} className="flex items-center justify-between py-2">
                <span className="text-sm text-gray-700">{c.name}</span>
                <span className="flex items-center text-sm text-gray-500"><div className={`w-2 h-2 rounded-full mr-2 ${COLOR[c.status] || 'bg-gray-400'}`} />{c.detail || c.status}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
